export default __webpack_public_path__ + "static/media/linkedin-white-logo.40c9ba44.svg";